import React from 'react';

import RoundPlay from '../../assets/icons/emptyPlay.svg?react'
import styles from './Thumbnail.module.css'
import { Typography, useMediaQuery } from '@mui/material';
import ExpandableParagraph from '../common/ExpandableParagraph';
import { useAppSelector } from '../../redux/hooks';
import { selectDirection } from '../../redux/selectors';
import { createImageUrl } from '../../services/data';
import { addDefaultSource } from '../../services/errorHandlers';
import { useNavigate } from 'react-router-dom';

interface RoundImageProps {
  img: string;
  title: string;
  description: string;
  id: string;
  onClick?: () => void;
}

const RoundImage: React.FC<RoundImageProps> = ({img, title, description, id, onClick}) => {
    const isMobile = useMediaQuery('(max-width:600px)')
    const navigate = useNavigate()
    const direction = useAppSelector(selectDirection)

    const handleOnClick = () => {
        if (isMobile) {
            navigate(`${id}`)
        } else {}
    }

    return (
        <div className={styles.roundImage} dir={direction} >
            <div className={styles.imageWrapper} onClick={handleOnClick} style={{overflow: 'unset', cursor: 'pointer'}}>
                <img src={createImageUrl(img)} alt='thubmnail' onError={addDefaultSource} />
                {isMobile && <RoundPlay aria-label='play' className={styles.overlay} style={{bottom: '-3rem', borderRadius: '50%', backgroundColor: '0C003B', }}/>}
            </div>
            <div className={styles.body}>
                <Typography variant='h3' mb='0.5rem' fontFamily={'FbReforma'} fontWeight={500}
                    sx={{
                        fontSize: {md: '4rem'},
                        mb: {xs: '0.5rem', md: '2.5rem'}
                    }}
                >
                    {title}
                </Typography>
                <ExpandableParagraph content={description} fontFamily={'FbReforma'} fontWeight={400} />
            </div>
        </div>
    );
};

export default RoundImage;
